// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { foodSessionId } from './FoodSession';
import { foodProjectId } from './FoodProject';
import { z } from 'zod';
export const foodTestRoundId = (z.number());
export const foodTestRound = z.object({
    id: foodTestRoundId,
    round_number: z.number(),
    notes: z.string().nullable(),
    assignee_id: operatorId.nullable(),
    completed_at: z.date().nullable(),
    completed_by: operatorId.nullable(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
    session_id: foodSessionId.nullable(),
    project_id: foodProjectId.nullable(),
});
export const foodTestRoundInitializer = z.object({
    id: foodTestRoundId.optional(),
    round_number: z.number(),
    notes: z.string().optional().nullable(),
    assignee_id: operatorId.optional().nullable(),
    completed_at: z.date().optional().nullable(),
    completed_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    session_id: foodSessionId.optional().nullable(),
    project_id: foodProjectId.optional().nullable(),
});
export const foodTestRoundMutator = z.object({
    id: foodTestRoundId.optional(),
    round_number: z.number().optional(),
    notes: z.string().optional().nullable(),
    assignee_id: operatorId.optional().nullable(),
    completed_at: z.date().optional().nullable(),
    completed_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    session_id: foodSessionId.optional().nullable(),
    project_id: foodProjectId.optional().nullable(),
});
//# sourceMappingURL=FoodTestRound.js.map